// extracted by mini-css-extract-plugin
module.exports = {"contents":"_1985F2_TL47VOuqfUl4Eo"};